import React from "react";
import { BrowserRouter } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import MainScreen from "./pages/MainScreen";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEyeSlash, faEye, faSearch, faChevronUp, faChevronDown, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import './css/App.css';

library.add(faEyeSlash, faEye, faSearch, faChevronUp, faChevronDown, faTimesCircle);

const THEME = createTheme({
   typography: {
    "fontFamily": `"Catamaran", "Roboto", "Helvetica", "Arial", sans-serif`,
    "fontSize": 14,
    "fontWeightLight": 300,
    "fontWeightRegular": 400,
    "fontWeightMedium": 500
   }
});

function App() {
    return (
      <ThemeProvider theme={THEME}>
      <CssBaseline />
        <BrowserRouter>
            <Container fluid className="p-0">
                <MainScreen />
            </Container>
        </BrowserRouter>
      </ThemeProvider>
    );
}

export default App;
